var _circle, _rect, _circle2, _circle3, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyUpcomingClasses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#F5F4F4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 21,
    width: 30,
    height: 29,
    rx: 2,
    fill: "#CECACA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 26,
    r: 2,
    fill: "#F5F4F4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 26,
    r: 2,
    fill: "#F5F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 26H43",
    stroke: "#9C9696",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "matrix(1 0 0 -1 23 37)",
    fill: "#ECEAEA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "matrix(1 0 0 -1 30 37)",
    fill: "#ECEAEA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "matrix(1 0 0 -1 37 37)",
    fill: "#ECEAEA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "matrix(1 0 0 -1 44 37)",
    fill: "#ECEAEA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "matrix(1 0 0 -1 23 45)",
    fill: "#ECEAEA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "matrix(1 0 0 -1 30 45)",
    fill: "#ECEAEA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "matrix(1 0 0 -1 37 45)",
    fill: "#ECEAEA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    transform: "matrix(1 0 0 -1 44 45)",
    fill: "#ECEAEA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyUpcomingClasses);
export default __webpack_public_path__ + "static/media/emptyUpcomingClasses.0145302ba3cccdf0da90851023377fe7.svg";
export { ForwardRef as ReactComponent };